export default {
	sec_10: {
		title: {
			one: 'JP WORLD Pay ',
			two: 'merchant registration',
		},
		desc: {
			one: 'Payments made by customers are settled by ',
			two: 'each registered merchant.',
		},
		btn: {
			one: 'Sign up',
			two: 'Download App',
		},
	},
	sec_11: {
		one: {
			title: {
				one: 'Even if there are many affiliated stores,',
				two: 'all settlements are made at once.',
			},
			desc: {
				one: 'It is calculated meticulously, down to each item, without missing anything.',
			},
		},
		two: {
			title: {
				one: 'Pay any time, any way you want',
			},
			desc: {
				one: 'You can pay with cryptocurrency and any currency pair you want.',
			},
		},
	},
};
